import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import ControlledPlaceAutocompleteV2 from "@components/ControlledPlaceAutocompleteV2";
import { GuaranteeVehicleDetailConfig } from "@interfaces/catalogs";
import { GarantiaFieldBindings } from "@interfaces/informacionMultiGarantias";
import { onlyDigits } from "@helpers/informacionMultiGarantiasHelpers";
import { FieldWrapper } from "../FieldWrapper";
import { SectionHeader } from "../SectionHeader";
import { TextFieldSelectDetalle } from "./TextFieldSelectDetalle";

export interface UbicacionGarantia {
  address: string;
  lat: number;
  lng: number;
}

interface Props extends GarantiaFieldBindings {
  /** Tipos de inmueble del catálogo del tipo de garantía. */
  details: GuaranteeVehicleDetailConfig[];
  /** La pantalla decide si guarda coordenadas (selección o mapa) o las limpia (tipeo manual). */
  onUbicacionChange: (value: UbicacionGarantia) => void;
}

/** Rama inmobiliaria de `S_Garantia`: tipo de inmueble, valor estimado y ubicación, uno debajo del otro. */
export const FormGarantiaInmobiliariaV2 = ({
  item,
  disabled,
  testId,
  fieldError,
  touchField,
  setField,
  details,
  onUbicacionChange,
}: Props) => (
  <Box>
    {/* Sin divider: en el diseño el detalle sigue al tipo de garantía solo con espacio. */}
    <SectionHeader label="Detalle de tu garantía inmobiliaria" first />
    <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
      <FieldWrapper label="Tipo de inmueble" full error={fieldError("type_inmobiliaria")}>
        <TextFieldSelectDetalle
          value={item.type_inmobiliaria}
          details={details}
          onChange={(value) => setField("type_inmobiliaria", value)}
          onBlur={() => touchField("type_inmobiliaria")}
          disabled={disabled}
          testId={testId("inmueble-select")}
        />
      </FieldWrapper>

      <FieldWrapper label="Valor estimado" full error={fieldError("valor_estimado")}>
        <TextField
          autoComplete="off"
          size="lendia_input"
          fullWidth
          value={item.valor_estimado}
          onBlur={() => touchField("valor_estimado")}
          // TODO: paridad con el legacy inmobiliario — al vaciar el campo queda "0" (el
          // formulario vehicular sí lo deja vacío). Confirmar cuál comportamiento se queda.
          onChange={(event) =>
            setField("valor_estimado", Number(onlyDigits(event.target.value)).toLocaleString("en-US"))
          }
          placeholder="2,000,000"
          disabled={disabled}
          inputProps={{ inputMode: "numeric", maxLength: 20, "data-testid": testId("valor-input") }}
          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
        />
      </FieldWrapper>

      <FieldWrapper label="Ubicación del bien" full error={fieldError("ubicacion")}>
        <ControlledPlaceAutocompleteV2
          label={null}
          value={{ address: item.ubicacion, lat: Number(item.latitud) || 0, lng: Number(item.longitud) || 0 }}
          onChange={onUbicacionChange}
          onBlur={() => touchField("ubicacion")}
          error={Boolean(fieldError("ubicacion"))}
          disabled={disabled}
        />
      </FieldWrapper>
    </Box>
    <Typography variant="body3" color="text.secondary" sx={{ display: "block", mt: 1.5 }}>
      Autocompletado con Google Maps.
    </Typography>
  </Box>
);
